export const TEXT_SIZES = [10, 12, 14, 16, 18, 24, 36, 48, 64, 80, 144, 288];
